import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AnalyticsService } from '../services/analytics.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AnalyticsEventsInterceptor implements HttpInterceptor {
  constructor(private analyticsService: AnalyticsService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isTenantApiCall = req.url.startsWith(environment.apiUrl);
    if (!isTenantApiCall) {
      return next.handle(req);
    }

    const requestStartedAt = Date.now();
    const apiPath = this.normalizeApiPath(req.url);
    this.analyticsService.trackEvent('api_request_started', {
      method: req.method,
      api_path: apiPath
    });

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.analyticsService.trackEvent('api_request_succeeded', {
            method: req.method,
            api_path: apiPath,
            status_code: event.status,
            duration_ms: Date.now() - requestStartedAt
          });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.analyticsService.trackEvent('api_request_failed', {
          method: req.method,
          api_path: apiPath,
          status_code: error.status || 0,
          duration_ms: Date.now() - requestStartedAt,
          reason: (error.error?.error?.reasonCode || error.message || 'unknown').toString().slice(0, 100)
        });
        return throwError(() => error);
      })
    );
  }

  private normalizeApiPath(url: string): string {
    const withoutBase = url.replace(environment.apiUrl, '');
    const noQuery = withoutBase.split('?')[0] || '/';
    return noQuery.replace(/\d{6,}/g, ':id').slice(0, 100);
  }
}
